import { useDispatch } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";

export const useSnapApplication = (id: string) => {
  const dispatch = useDispatch();

  return useQuery({
    queryKey: ["getSnapApplication", id],
    queryFn: async () =>
      dispatch(apiThatThrows.getSnapApplication.action({ params: { id } })),
  });
};
